import React, { useRef, useState } from 'react';
import Button from 'components/Button';
import FormContainer from 'components/LoanForm/FormContainer';
import CheckboxSmall from 'components/Checkbox/CheckboxSmall';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { createPaymentAccount, getApplicationData } from 'thunks';
import { useSelector } from 'react-redux';
import { getApplicationData as getApplicationDataSelector } from 'selectors/getApplicationData';
import { getPaymentAccountData } from 'selectors/paymentAccount';
import { RootState } from 'handlers';
import FormNavigation from 'components/FormNavigation';
import { FlowComponentType } from 'routes/types';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'enums/Routes';

import styles from './OpenDDA.module.scss';

const privacyNoticeUrl = 'https://assets.planneryapp.com/deposit-account/plannery-finwise-privacy-policy.pdf';

const OpenDDA = ({ navigationInfo, handleNext }: FlowComponentType) => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const navigate = useNavigate();

  const bottomRef = useRef<HTMLDivElement>(null);

  const [acceptTerms, setAcceptTerms] = useState<boolean>(false);

  const { application } = useSelector(getApplicationDataSelector);
  const { status } = useSelector(getPaymentAccountData);

  const { isLoading: isFetchingEmployerData } = useSelector((state: RootState) => state.employers).getEmployerData;

  const buttonDisabled = !acceptTerms || isFetchingEmployerData;

  const { isLoading } = status.createPaymentAccount;

  const applicationId = application?.id;

  const handleContinue = async () => {
    analytics.track('Create DDA Account Started');
    await dispatchWithUnwrap(createPaymentAccount({ applicationId: applicationId!, waitTimeMillis: 60000 }));
    await dispatchWithUnwrap(getApplicationData(applicationId!));
    handleNext();
  };

  const handleBackClick = () => {
    navigate(RoutePath.RepaymentMethod);
  };

  return (
    <>
      <FormNavigation {...navigationInfo} onBackClick={handleBackClick} />
      <FormContainer title="Open direct deposit account" subtitle="It's only used for your loan payments.">
        <div className={styles.cardContainer}>
          <p>
            By clicking below, you give us permission to open a direct deposit account on your behalf with FinWise Bank,
            Member FDIC.* Review and accept the disclosure below.
          </p>

          <CheckboxSmall
            withShadow
            onChange={() => setAcceptTerms(!acceptTerms)}
            disabled={isLoading}
            checked={acceptTerms}
            label={
              <a target="_blank" rel="noopener noreferrer" className={styles.termsLink} href={privacyNoticeUrl}>
                Privacy notice
              </a>
            }
          />
        </div>

        <Button isLoading={isLoading} disabled={buttonDisabled} onClick={handleContinue}>
          Open direct deposit account
        </Button>
      </FormContainer>
      <div ref={bottomRef} />
    </>
  );
};

export default OpenDDA;
